<template>
  <div class="container border-bottom rounded py-2 mb-3">
    <div class="">

      <div class="d-inline-block ">
        <i class="bi bi-filter"></i>
        <span v-t="`filter.sort_price.title`"></span>
      </div>

      <template v-if="publishStatusFilter">
        <div @click="setProductStatus('all')" :class="[publishStatusType ==='all' ? 'active' : '']" class="item ">
          <span v-t="`filter.product_status.all`"></span>
        </div>

        <div @click="setProductStatus(1)" :class="[publishStatusType ===1 ? 'active' : '']"
             class="item ">
          <span v-t="`filter.product_status.publish`"></span>
        </div>

        <div @click="setProductStatus(0)" :class="[publishStatusType ===0 ? 'active' : '']" class="item ">
          <span v-t="`filter.product_status.draft`"></span>
        </div>
      </template>

      <div @click="setSortType('min_price','asc')" :class="[sortType ==='asc' ? 'active' : '']" class="item ">
        <span v-t="`filter.sort_price.lowest_price`"></span>
      </div>

      <div @click="setSortType('max_price','desc')" :class="[sortType ==='desc' ? 'active' : '']" class="item ">
        <span v-t="`filter.sort_price.highest_price`"></span>
      </div>


    </div>

  </div>
</template>

<script>
export default {
  name: "SortPriceFilter",
  props: {
    publishStatusFilter: {
      default: false,
      type: Boolean,
    }
  },
  data() {
    return {
      sortType: '',
      publishStatusType: '',
    }
  },
  methods: {
    // low => min_price,asc
    // high => max_price,desc
    setSortType(column, type) {
      this.sortType = type
      this.$emit('sort', `${column},${type}`)
    },
    setProductStatus(value) {
      this.publishStatusType = value
      this.$emit('publishStatus', value)
    }
  }
}
</script>

<style scoped>
.item {
  display: inline-block;
  margin-right: 15px;
  cursor: pointer;
}

.item.active {
  color: var(--primary);
  font-weight: bolder;
}
</style>